import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.5005 3C10.7441 2.99997 11.9615 3.35667 13.0084 4.02777C14.0554 4.69886 14.8878 5.65619 15.407 6.78618C15.9262 7.91616 16.1104 9.17136 15.9376 10.4029C15.7649 11.6344 15.2425 12.7905 14.4325 13.734L20.0765 19.378L19.3695 20.085L13.7245 14.44C12.9284 15.1208 11.9795 15.5991 10.9587 15.8342C9.93786 16.0693 8.87535 16.0542 7.86163 15.7901C6.84792 15.5261 5.91304 15.021 5.13661 14.3178C4.36018 13.6146 3.76521 12.7341 3.40237 11.7514C3.03953 10.7687 2.91958 9.71291 3.05271 8.67387C3.18585 7.63483 3.56814 6.64336 4.16703 5.7839C4.76591 4.92444 5.56364 4.22246 6.49229 3.73774C7.42093 3.25302 8.45297 2.99992 9.5005 3ZM9.5005 4C8.04181 4 6.64286 4.57946 5.61141 5.61091C4.57996 6.64236 4.0005 8.04131 4.0005 9.5C4.0005 10.9587 4.57996 12.3576 5.61141 13.3891C6.64286 14.4205 8.04181 15 9.5005 15C10.9592 15 12.3581 14.4205 13.3896 13.3891C14.421 12.3576 15.0005 10.9587 15.0005 9.5C15.0005 8.04131 14.421 6.64236 13.3896 5.61091C12.3581 4.57946 10.9592 4 9.5005 4Z",
      fill: "black"
    }, null, -1)
  ]))]))
}